import {useNavigate, useParams} from 'react-router-dom';
import { useState, useEffect } from 'react';
import {get} from '../helpers/httpClient';
import GalleryRenderer from '../helpers/renderer/galleryRenderer';
import GalleryScaledRenderer from '../helpers/renderer/galleryScaledRenderer';
import Catalog from './component/catalog';
import Article from './component/article';
import Gallery from './component/gallery';
import GalleryItem from './component/galleryItem';
import Poster from './component/poster';

function App() {
    const params = useParams();
    const [page, setPage] = useState(null);
    const navigate = useNavigate();

    const [isLargeScreen, setIsLargeScreen] = useState(window.innerWidth > 768);

    useEffect(() => {
        const handleResize = () => setIsLargeScreen(window.innerWidth > 768);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        const getPage = async () => {
            let slug = params['*'];
            if (!slug) {slug = ''}
            try {
                const response = await get('pages?slug=' + slug);
                if (response) {
                    setPage(response.page);
                    if (response.page?.title) {
                        document.title = document.title + ' - ' + response.page.title;
                    }
                }
            } catch (error) {
                navigate('/404')
            }
        };

        getPage();
    }, [params]);

    useEffect(() => {
        if (page?.type === 'poster') {
            document.body.classList.add('poster-page');
            return () => document.body.classList.remove('poster-page');
        }
    }, [page?.type]);

    if (!page) return null;

    if (page.type === 'poster') {
        return <Poster info={page} />;
    }

    const components = page.components?.items || [];
    const containerHeight = 32 * 16;

    const renderComponent = (comp, idx) => <GalleryRenderer key={idx} comp={comp} />;
    const renderScaledComponent = (comp, idx) => <GalleryScaledRenderer key={idx} comp={comp} containerHeight={containerHeight} isLargeScreen={isLargeScreen} />;

    const getComponentsForPosition = (pos) => {
        return components.filter(comp => {
            const currentPos = isLargeScreen ? comp.positionWideScreen : comp.positionSmallScreen;
            return currentPos === pos;
        });
    };

    const topComponents = getComponentsForPosition('top');
    const bottomComponents = getComponentsForPosition('bottom');
    const leftComponents = getComponentsForPosition('left');
    const rightComponents = getComponentsForPosition('right');

    return (
        <div className="page-container">
            <div className="page-layout">
                <div className={"page-top"}>
                    {topComponents.map(renderScaledComponent)}
                </div>

                <div className="page-main-wrapper">
                    {isLargeScreen && leftComponents.length > 0 && (
                        <div className="page-side page-left">
                            {leftComponents.map(renderComponent)}
                        </div>
                    )}

                    <div className="page-center">
                        <div className="d-flex justify-content-center">
                            {page.type === 'article' && <Article info={page} />}
                            {page.type === 'catalog' && <Catalog info={page} />}
                            {page.type === 'gallery' && <Gallery info={page} />}
                            {page.type === 'galleryitem' && <GalleryItem info={page} />}
                        </div>
                    </div>

                    {isLargeScreen && rightComponents.length > 0 && (
                        <div className="page-side page-right">
                            {rightComponents.map(renderComponent)}
                        </div>
                    )}

                    {!isLargeScreen && [...leftComponents, ...rightComponents].map(renderComponent)}
                </div>

                <div className={"page-bottom"}>
                    {bottomComponents.map(renderScaledComponent)}
                </div>
            </div>
        </div>
    );
}

export default App;